import { render, staticRenderFns } from "./SmtpsTable.vue?vue&type=template&id=97dd710a&scoped=true&"
import script from "./SmtpsTable.vue?vue&type=script&lang=js&"
export * from "./SmtpsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dd710a",
  null
  
)

export default component.exports